import { Box } from "@mui/material";
import { GetFontAwesomeIcon } from "../font-awesome-icon";
import { useTheme } from "@emotion/react";
import { SortDirEnum } from "@/services/dropdown-enums";
import { faSortAsc, faSortDesc } from "@fortawesome/free-solid-svg-icons";

const Styles = {
  sortBtn: { fontSize: "13px", position: "absolute" },
};

const TableSort = ({ onSortClick, column, sortInfo = {} }) => {
  const { palette } = useTheme();

  const getSortIconColor = (colName = "", dir = "") => {
    if (sortInfo?.colName == colName && sortInfo?.dir && sortInfo?.dir != dir) {
      return palette.base[80];
    }
    return palette.base[100];
  };
  return (
    <Box
      className={"cursor-pointer"}
      sx={{
        display: "inline-block",
        marginLeft: 1,
        position: "relative",
        width: 10,
        height: 16,
        flexShrink: 0,
      }}
    >
      <GetFontAwesomeIcon
        icon={faSortDesc}
        iconStyles={{
          color: getSortIconColor(column.name, SortDirEnum.DESC),
          top: 0,
          left: 0,
          marginRight: 0,
          ...Styles.sortBtn,
        }}
      />
      <GetFontAwesomeIcon
        icon={faSortAsc}
        iconStyles={{
          color: getSortIconColor(column.name, SortDirEnum.ASC),
          top: 0,
          left: 0,
          marginRight: 0,
          ...Styles.sortBtn,
        }}
      />
    </Box>
  );
};

export default TableSort;
